import { Header } from './components/Header.js';
import { AboutPage } from './pages/AboutPage.js';
import { HomePage } from './pages/HomePage.js';
import { SettingsPage } from './pages/SettingsPage.js';
import { AttemptIdProvider } from './state/AttemptIdContext.js';
import { DeviceProvider } from './state/DeviceProvider.js';
import { DiagnosticsProvider } from './state/DiagnosticsProvider.js';
import { LogsProvider } from './state/LogsProvider.js';
import { SettingsProvider } from './state/SettingsProvider.js';
import { useRoute } from './router.js';

export function App() {
  // DeviceProvider is innermost: useSoluuDevice consumes both the diagnostics
  // sink and the attempt-id ref, so it has to mount inside them.
  return (
    <SettingsProvider>
      <LogsProvider>
        <DiagnosticsProvider>
          <AttemptIdProvider>
            <DeviceProvider>
              <AppShell />
            </DeviceProvider>
          </AttemptIdProvider>
        </DiagnosticsProvider>
      </LogsProvider>
    </SettingsProvider>
  );
}

function AppShell() {
  const [route] = useRoute();
  return (
    <div className="app">
      <Header />
      {route === '/settings' ? (
        <SettingsPage />
      ) : route === '/about' ? (
        <AboutPage />
      ) : (
        <HomePage />
      )}
    </div>
  );
}
